import React, { Component } from "react";

    function toDisplayString(seconds)
    {
        if (!seconds) return "--";
        let x = new Date(seconds * 1000).toISOString();
        return  (seconds < 3600) ? 
            new Date(seconds * 1000).toISOString().substring(14, 19)
            :
            new Date(seconds * 1000).toISOString().substring(11, 19)
    };



export default class ExpirationTimer extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isRunning: false,
            expirationDate: new Date(),
            secondsRemaining: 0,
            expirationDisplay: ""
        }

        this.reset = this.reset.bind(this);
        this.start = this.start.bind(this);
        this.stop = this.stop.bind(this);
        this.update = this.update.bind(this);
        this.expire = this.expire.bind(this);
        this.interval = null;
    }

    componentDidMount()
    {
        this.stop();
        this.reset(this.props.expires);
        this.start();
    }


    componentDidUpdate(prevProps, prevState)
    {
        if (this.props.expires != prevProps.expires)
        {
            this.stop();
            this.reset(this.props.expires);
            this.start();
        }
    }

    componentWillUnmount()
    {
        this.stop();
    }


    reset(expirationDate)
    {
        // how many seconds? 
        let secondsRemaining = (expirationDate - new Date()) / 1000;
        let expirationDisplay = toDisplayString(secondsRemaining);
        this.setState({
            isRunning: false,
            expirationDate: expirationDate,
            secondsRemaining: secondsRemaining,
            expirationDisplay: expirationDisplay
        });
    }


    start()
    {
        if (this.state.isRunning) return;
        this.interval = setInterval(() => {
            this.update(this.state.secondsRemaining - 1);
          }, 1000);
    }

    stop()
    {
        this.setState({
            isRunning: false
        })
        clearInterval(this.interval);
    }

    update(secondsRemaining)
    {
        if (secondsRemaining < this.props.expireSecondsLeft)
        {
            console.log("Seconds Remaining: " + secondsRemaining);
            console.log("Seconds Left: " + this.props.expireSecondsLeft);
            this.expire();
        }
        this.setState({secondsRemaining: secondsRemaining});
        this.setState({expirationDisplay : toDisplayString(secondsRemaining)});
    }


    expire()
    {
        console.log("Purposefully expiring from Expiration Timer");
        this.stop();
        this.props.onExpiredToken();
    }



    render() {
        var isConnected = this.props.onlineInfo?.isConnected;
        var expToDisplay = "";
        if (isConnected)
        {
            var inAlert = (this.props.alertSecondsLeft > this.state.secondsRemaining);
            expToDisplay = (this.state.secondsRemaining < this.props.alertSecondsLeft) ? "" : "Your session will expire in " + this.state.expirationDisplay;
        }
        else 
        {
            expToDisplay = "offline";
        }
            return (
            <div style={{color: (inAlert) ? "red": "lightgrey", fontSize: (inAlert) ? "24px" : "12px"}}>
                {expToDisplay}
            </div>
        )
    }
}